import { AiModal } from '@ui/modals';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { resetAnalysisPeriscope } from '../../global/redux/application/actions';

import { PeriscopeCard, SonarObjectType } from '@sonar-software/sonar-ts-types';
import { useAction, useSonarObjectReference, useSonarSelector } from '@hooks';

const titleMap: Partial<Record<SonarObjectType, string>> = {
	[ SonarObjectType.SalesforceApexClass ]: COPY_SPECIFIC.AI_EXPLAIN,
	[ SonarObjectType.SalesforceValidationRule ]: COPY_SPECIFIC.AI_FIX
};

const urlMap: Partial<Record<SonarObjectType, (id: number) => string>> = {
	[ SonarObjectType.SalesforceApexClass ]: (id: number) => `/api/v3/open-ai/chat/apex-class/${id}`,
	[ SonarObjectType.SalesforceValidationRule ]: (id: number) => `/api/v3/open-ai/chat/validation-rule-issue/${id}`
};

export const PeriscopeAnalysisModal: React.FC = () => {
	const target = useSonarSelector((state) => state.application.periscope.analysisTarget);

	const close = useAction(resetAnalysisPeriscope);

	const sonarObjectId = target?.id ?? 0;
	const type = target?.type ?? SonarObjectType.SalesforceApexClass;

	const { sourceUrl } = useSonarObjectReference(sonarObjectId);

	const periscope: PeriscopeCard = {
		id: sonarObjectId,
		name: '',
		type
	};

	const urlFn = urlMap[ type ];
	const url = urlFn ? urlFn(sonarObjectId) : '';

	return <AiModal
		className='periscope-analysis-modal'
		onClose={ close }
		open={ Boolean(target) }
		periscope={ periscope }
		salesforceUrl={ sourceUrl }
		showIcon
		sourceUrl={ url }
		title={ titleMap[ type ] ?? COPY_SPECIFIC.AI_EXPLAIN } />;
};
